function buttons(){
    "use strict";

    const input = document.querySelector('input.wpcf7-submit');

    if (input) {
        const button = document.createElement('button');
        button.type = 'submit';
        button.className = input.className;
        button.innerHTML = `<span class="text">${input.value}</span> <span class="arrow"></span>`;

        input.parentNode.replaceChild(button, input);
    }
}

function menu(){
    "use strict";

    jQuery(".site-header .mobile-menu").click(function(e){
        e.preventDefault();
        jQuery("body").toggleClass('active-menu');
    });
}

function clipboard(){
    "use strict";

    jQuery(".copy-address").click(function(e){
        e.preventDefault();
        copyToClipboard(jQuery(this).attr('title'));
    });
}

function copyToClipboard(text) {
    "use strict";

    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
}

function gallery() {
    const gallerySlider = jQuery('.gallery-list').slick({
        dots : false,
        infinite : true,
        speed : 300,
        fade: false,
        cssEase: 'linear',
        slidesToShow : 2,
        slidesToScroll : 1,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        appendArrows: jQuery('.gallery-nav'),
    });
}

function homeSlider() {
    const gallerySlider = jQuery('.business-park .imgs').slick({
        dots : false,
        infinite : true,
        speed : 300,
        fade: true,
        cssEase: 'linear',
        slidesToShow : 1,
        slidesToScroll : 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: false,
        //appendArrows: jQuery('.gallery-nav'),
    });
}

function newsFilter() {
    jQuery(document).on('change', 'form select', function() {
        jQuery(this).closest('form').submit();
    });
}

function formFiller() {
    jQuery(document).ready(function() {
        jQuery("input[name='your-page']").val(window.location.href);
    });
}

jQuery(document).ready(function () {
    "use strict";

    buttons();
    menu();
    clipboard();
    gallery();
    homeSlider();
    newsFilter();
    formFiller();

    jQuery(window).scroll(function () {
        const header = jQuery('body');
        const scroll = jQuery(window).scrollTop();
        if (scroll >= 35) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    });

});
